export const LANGUAGES = {
  en: "en",
  ru: "ru",
};
